var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-user-list',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"users":_vm.users,"detail-link":"driver-edit","new-link":"driver-new","show-filter":""},on:{"get-page":_vm.loadData}})}
var staticRenderFns = []

export { render, staticRenderFns }